import { render, staticRenderFns } from "./EliViewActPage.vue?vue&type=template&id=68fc6468&"
import script from "./EliViewActPage.vue?vue&type=script&lang=js&"
export * from "./EliViewActPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports